import { useEffect, useRef } from 'react';
import {
  StyledSearch,
  StyledSearchIconWrapper,
  StyledInputBase,
} from './Search.style';
import { SearchIcon } from '../../icons/SearchIcon';
import { ClearIcon } from '../../icons/ClearIcon';

interface SearchProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const Search = (props: SearchProps) => {
  const { placeholder = 'Search...', value = '', onChange } = props;
  const searchRef = useRef<HTMLInputElement>();

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = value;
    }
  }, [value]);

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      const newValue = searchRef?.current?.value;
      onChange(newValue);
    }
  }

  function handleButtonClick() {
    if (value) {
      onChange(undefined);
      searchRef?.current.focus();
      return;
    }

    onChange(searchRef?.current?.value);
  }

  return (
    <StyledSearch isSearched={!!value}>
      <StyledInputBase
        inputProps={{ 'aria-label': 'search' }}
        inputRef={searchRef}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
      />
      <StyledSearchIconWrapper
        onClick={handleButtonClick}
        data-testid='search-clear'
      >
        {value ? <ClearIcon /> : <SearchIcon size='1.3rem' />}
      </StyledSearchIconWrapper>
    </StyledSearch>
  );
};
